import React from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";
import { Menu, Dropdown as AntDropdown } from "antd";
import { UiDropdown } from "./Dropdown.style";
/**
 * 下拉選單
 */

const Dropdown = ({
  list,
  children,
  className
}) => {
  return /*#__PURE__*/React.createElement(AntDropdown, {
    overlay: /*#__PURE__*/React.createElement(Menu, null, list.map((li, key) => {
      return /*#__PURE__*/React.createElement(Menu.Item, {
        key: key,
        onClick: () => li.onClick && li.onClick(),
        style: {
          display: "flex",
          alignItems: "center"
        }
      }, li.icon && /*#__PURE__*/React.createElement(Icon, {
        style: {
          marginRight: "5px"
        },
        name: li.icon
      }), li.name);
    }))
  }, /*#__PURE__*/React.createElement(UiDropdown, {
    className: className
  }, children));
};

export default Dropdown;
Dropdown.propTypes = {
  list: PropTypes.array,
  children: PropTypes.element,
  className: PropTypes.string
};